<template>
  <div class="aboutUs">
    <div class="container">
      <div class="aboutUs-header">
        <swiper></swiper>
      </div>
      <div class="aboutUs-contens">
        <div class="item-aboutUs-contens">
          <div class="aboutUs-title"><i></i>关于我们<i></i></div>
          <div class="aboutUs-content">
            <div class="item-aboutUs">
              <div class="aboutUs-box" v-for="(item,index) in ourList" :key="index">
                <div class="item-box-bg">
                  <img :src="item.img" />
                </div>
                <div class="item-box-title">{{item.txt}}</div>
                <div class="item-box-cons">{{item.content}}</div>
              </div>
            </div>
          </div>
          <div class="aboutUs-map">
            <baidu-map :center="center" :zoom="zoom" @ready="handler" style="height:400px" @click="getClickInfo" :scroll-wheel-zoom='true'>
            </baidu-map>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { login } from '../api/index'
import Swiper from '../components/swiper.vue'
export default {
  name: 'aboutUs',
  components: {
    Swiper
  },
  data () {
    return {
      ourList: [
        {img: require('../assets/icon/map.png'), txt: '公司地址', content: '北京市朝阳区望京科技园'},
        {img: require('../assets/icon/mail.png'), txt: '客服热线', content: '18612518705'},
        {img: require('../assets/icon/phone.png'), txt: '公司邮箱', content: 'hr@tongxinyizhi.com'}
      ],
      center: {lng: 116.480311, lat: 40.018396},
      zoom: 19
    }
  },
  methods: {
    handler ({BMap, map}) {
      var point = new BMap.Point(116.480311, 40.018396)
      map.centerAndZoom(point, 19)
      var marker = new BMap.Marker(point) // 创建标注
      map.addOverlay(marker) // 将标注添加到地图中
      var opts = {
        position: point,
        offset: new BMap.Size(30, -30)
      }
      var label = new BMap.Label('北京童心弈智科技有限公司', opts)
      label.setStyle({
        color: 'black',
        fontSize: '12px',
        height: '20px',
        lineHeight: '20px',
        fontFamily: '微软雅黑',
        border: '1px solid black'
      })
      map.addOverlay(label)
      var circle = new BMap.Circle(point, 6, {
        strokeColor: 'Red',
        strokeWeight: 6,
        strokeOpacity: 1,
        Color: 'Red',
        fillColor: '#ff0033'
      })
      map.addOverlay(circle)
    },
    getClickInfo (e) {
      console.log(e.point.lng)
      console.log(e.point.lat)
      this.center.lng = e.point.lng
      this.center.lat = e.point.lat
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../assets/scss/base.scss";
  @import "../assets/scss/mixin.scss";
  @import "../assets/scss/config.scss";
  .aboutUs{
    width: 100%;
    @media only screen and (min-width: 540px) and (max-width: 1180px){
      width: 1180px;
    }
    .container{
      width: 100%;
      .aboutUs-header{
        width: 100%;
        height: 450px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .aboutUs-contens {
        width: 1180px;
        text-align: center;
        margin: auto;
        margin-top: 40px;
        .item-aboutUs-contens {
          width: 100%;
          margin-bottom: 45px;
          .aboutUs-title {
            color: $colorB;
            font-size: $fontB;
            font-weight: bold;
            // @include bgImg(230px, 40px, '../assets/imgs/xian.png');
            i{
              display: inline-block;
              width: 23px;
              height: 23px;
              margin-right: 26px;
              @include bgImg(23px,23px,'../assets/imgs/san_left.png');
            }
            i:last-of-type{
              margin-left: 26px;
              @include bgImg(23px,23px,'../assets/imgs/san_right.png');
            }
          }
          .aboutUs-content {
            width: 1180px;
            margin: auto;
            margin-top: 35px;
            margin-bottom: 60px;
            .item-aboutUs{
              width: 100%;
              @include flex();
              .aboutUs-box {
                width: 100%;
                .item-box-bg{
                  width: 177px;
                  height: 177px;
                  margin: auto;
                  img{
                    width: 100%;
                    height: 100%;
                  }
                }
                .item-box-title {
                  margin-top: 20px;
                  font-size:16px;
                  font-family:Microsoft YaHei;
                  font-weight:400;
                  color:rgba(51,51,51,1);
                  margin-bottom: 10px;
                }
                .item-box-cons{
                  font-size:14px;
                  font-family:Microsoft YaHei;
                  font-weight:400;
                  color:rgba(102,102,102,1);
                }
              }
            }
            .item-brandIntr-concept {
              width: 674px;
              margin-right: 40px;
            }
          }
          .aboutUs-map {
            width: 1180px;
            height: 400px;
            background-color: #cecece;
            margin-bottom: 120px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/aboutUs.vue